import React from 'react'
import { Header } from '../../../components/common/Header'
import { useTranslation } from 'react-i18next'

import '../index.less'
import { ModalRecoveryKey } from '../../../components/user/ModalRecoveryKey'

export default function OtherUseraPage() {
  const { t } = useTranslation()
  return (
    <div className="Dashboard">
      <Header />
      <h1>{t('otherUsers.title')}</h1>
      <ModalRecoveryKey />
    </div>
  )
}
